<template>
  <header class="app-header">
    <div class="header-container">
      <router-link to="/" class="header-link">
        <div class="logo-container">
          <img
            :src="logo.src"
            :alt="logo.alt"
            class="logo"
            @error="handleLogoError"
          />
          <span class="logo-text">{{ siteName }} - Events</span>
        </div>
      </router-link>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useSiteConfig } from '@/composables/useSiteConfig'

const { logo, siteName } = useSiteConfig()

const handleLogoError = (event: Event) => {
  const img = event.target as HTMLImageElement
  img.src = '/images/move_into_light_2.png' // Fallback to default logo
}
</script>

<style scoped>
.app-header {
  background: var(--bg-dark, #183847);
  color: var(--text-light);
  padding: 1rem 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.header-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.header-link {
  text-decoration: none;
  color: inherit;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: 600;
  font-family: var(--font-heading);
  color: var(--text-light);
}

@media (max-width: 768px) {
  .logo {
    width: 40px;
    height: 40px;
  }

  .logo-text {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .logo {
    width: 35px;
    height: 35px;
  }

  .logo-text {
    font-size: 1rem;
  }
}
</style>